module.exports = __webpack_public_path__ + "static/arrow-down.e400b6b1dc6f7fca27382df1c376a799.svg";